import {DealOriginsDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
import { UserState } from '../../reducers/UserReducer';

const FUNCTION_CODE = 'GET_ALL_DEAL_ORIGINS';

export async function getAllDealOrigins(
    userData: UserState["userProfileData"],
    params: string,
    page: number
) {
    try {
        const result = await DealOriginsDao.getAllDealOrigins(userData?.userToken as string, params, page);

        return result;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la récupération de la liste des origines des affaires',
            error: error
        });
    }
}
